import React, { useState, useEffect, useMemo } from 'react';
import { Box, Paper, Text } from '@mantine/core';

import { useSearchParams } from 'react-router-dom';
import { useQuery, useLazyQuery } from '@apollo/client';

import '@fontsource/orbitron/700.css'; // For bold weight

import RepairsIndividualScorecardTabSet from './RepairsIndividualScorecardTabSet';

const RepairsIndividualScorecard = () => {

    return (
        <Paper shadow="md"   style={{ maxWidth: '100%',  }}>
            <Text
                component="h1"
                style={{
                    fontFamily: 'Orbitron, sans-serif',
                    color: '#FDB813',
                    fontStyle: 'italic',
                    fontSize: '1.5rem',
                    marginBottom: '16px',
                    textAlign: 'left'
                }}
            >
                Repairs Individual Scorecard
            </Text>
            <Box style={{ marginTop: 0 }}>
                <RepairsIndividualScorecardTabSet />
            </Box>
        </Paper>
    );
};

export default RepairsIndividualScorecard;